import { AUD_MOBILE_BANNER_TO_APP } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isExperimentActive } from '../../utils/experiments';

export const selectIsMobileBannerToAppExperimentEnabled = ({ experiments }: IApplicationState): boolean => {
  return isExperimentActive(experiments, AUD_MOBILE_BANNER_TO_APP, 'B');
};
